// extracted by mini-css-extract-plugin
export default {"category":"Category_category__msEU1","category__icon":"Category_category__icon__1DofI"};